import CircleCheck from '@/assets/svgs/circle-check.svg';
import { Account } from '@/lib/redux/app.slice';
import React from 'react';
import AccountAvatar from './AccountAvatar';

interface AccountSelectorDropdownItemProps {
  account: Account;
  isSelected: boolean;
  onSelect: (account: Account) => void;
}

const AccountSelectorDropdownItem: React.FC<AccountSelectorDropdownItemProps> = ({
  account,
  isSelected,
  onSelect,
}) => {
  return (
    <li>
      <button
        className="hover:bg-base-100 flex w-full items-center gap-3 rounded-md p-2 text-left transition-colors"
        onClick={() => onSelect(account)}>
        <AccountAvatar
          accountId={account.account_id}
          accountName={account.account_name}
          size="sm"
        />
        <div className="flex min-w-0 flex-1 flex-col">
          <span
            className="text-base-content truncate font-medium"
            title={account.account_name}>
            {account.account_name}
          </span>
          <span className="text-base-content/70 truncate text-sm">
            {account.account_id}
            {account.account_type === 'sub' && (
              <span className="ml-1 text-xs">(Sub)</span>
            )}
          </span>
        </div>
        {isSelected && <CircleCheck className="text-primary h-4 w-4" />}
      </button>
    </li>
  );
};

export default AccountSelectorDropdownItem;
